import { useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { useAuth } from './auth-context.tsx';
import { useTokenStore } from '../api/use-api.ts';
import { logout } from '../api/auth.ts';

/**
 * Shared sign-out so entry points cannot diverge on cache purging - the step
 * that stops the next user in this tab seeing the previous user's data on
 * first paint.
 */
export function useSignOut(): () => Promise<void> {
  const navigate = useNavigate();
  const store = useTokenStore();
  const queryClient = useQueryClient();
  const { clearTokens } = useAuth();

  return async () => {
    try {
      await logout(store);
    } finally {
      clearTokens();
      // Purge all cached personal data so the next session in this tab starts
      // clean (no previous-user data on first paint). Mirrored on login.
      queryClient.clear();
      await navigate('/login', { replace: true });
    }
  };
}
